document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".shopify-section--question-list")
    .forEach((questionListSection) => {
      questionListSection.addEventListener("click", (event) => {
        const eventPath = event.composedPath
          ? event.composedPath().slice(0, -2)
          : [];

        for (const element of eventPath) {
          const clickAction = element.getAttribute("data-click-action");
          if (!clickAction) continue;

          if (clickAction === "toggle-answer-content") {
            toggleAnswerContent(element, questionListSection);
            break;
          }
        }
      });
    });
});

function toggleAnswerContent(question, section) {
  const questionContainer = question.parentElement;
  if (!questionContainer) return;

  questionContainer.hasAttribute("data-active")
    ? questionContainer.removeAttribute("data-active")
    : questionContainer.setAttribute("data-active", "");
}
